import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=16341701"
import script from "../../controllers/transaction/transaction-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/transaction/transaction-detail.js?vue&type=script&lang=js&external"
import style0 from "./TransactionDetail.vue?vue&type=style&index=0&id=16341701&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports